import {Injectable, OnDestroy} from '@angular/core';

@Injectable()
export class DipRegistrationConfirmService implements OnDestroy {
  private boundOnBeforeUnload: (event: BeforeUnloadEvent) => void;

  constructor() {
  }

  start() {
    this.stop();
    window.addEventListener('beforeunload', this.boundOnBeforeUnload = (event: BeforeUnloadEvent) => this.onBeforeUnload(event));
  }

  stop() {
    if (this.boundOnBeforeUnload) {
      window.removeEventListener('beforeunload', this.boundOnBeforeUnload);
    }
  }

  onBeforeUnload(event: BeforeUnloadEvent): void {
    event.preventDefault();
    event.returnValue = '';
  }

  ngOnDestroy() {
    this.stop();
  }
}
